export { NameOnDocument } from './name-on-document.component';
